import type { DriverDataErrorResponse } from "@App/apis/rest/ayvens/driverData/responses/driverDataErrorResponse";

/**
 * Custom error class for driverData Api failures.
 */
export class DriverDataError extends Error {
  public response: DriverDataErrorResponse;
  constructor(error: DriverDataErrorResponse) {
    super(error.message);
    this.response = error;
    this.name = "DriverDataError";
    Object.setPrototypeOf(this, DriverDataError.prototype);
  }
}
